// 1.6.x legacy namespace. Everything produced by the 1.6.x importer hangs off
// this namespace so old `company_1`-style pointers resolve deterministically:
// `<businessId>:<rawCompanyId>`.

export const LEGACY_NS = 'legacy:1.6.x';

// Map a stale raw company id (the `company_N` value a 1.6.x device stored in
// `legacyBusinessId`) onto the business id it actually belongs to. Two devices
// that both imported the same 1.6.x backup get the SAME mapped business id —
// the idempotency guarantee that lets `ensureBusinessChangeEnqueued` and the
// import path deduplicate without inventing businesses.
export function legacyBusinessId(companyId: string): string {
  return companyId.startsWith('company_')
    ? `${LEGACY_NS}:${companyId}:business`
    : companyId;
}
